import { render, staticRenderFns } from "./CustomizeFolderModal.vue?vue&type=template&id=02f01d6f&scoped=true"
import script from "./CustomizeFolderModal.vue?vue&type=script&lang=js"
export * from "./CustomizeFolderModal.vue?vue&type=script&lang=js"
import style0 from "./CustomizeFolderModal.vue?vue&type=style&index=0&id=02f01d6f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f01d6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02f01d6f')) {
      api.createRecord('02f01d6f', component.options)
    } else {
      api.reload('02f01d6f', component.options)
    }
    module.hot.accept("./CustomizeFolderModal.vue?vue&type=template&id=02f01d6f&scoped=true", function () {
      api.rerender('02f01d6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/CustomizeFolderModal.vue"
export default component.exports